<template>
    <div class="flex flex-col min-h-screen">
        <impersonation-bar></impersonation-bar>

        <nav-bar></nav-bar>

        <slot></slot>
    </div>
</template>

<script>
import NavBar from '@/Parts/NavBar.vue'
import ImpersonationBar from '@/Parts/ImpersonationBar.vue'

export default {
    components: {
        NavBar,
        ImpersonationBar
    }
}
</script>

<style>

</style>
